//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
  state: {
    outbounds: [],
    searchRequest: null,
  },
  mutations: {
    updateOutbound(state, outbounds) {
      state.outbounds = outbounds;
    },
    updateSearchOutboundListRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async outboundsListList({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
      
      if (requestToSend.gwDate.startDate)
      {
         requestToSend.gwDate.startDate = dateFormat.getLocalDate(requestToSend.gwDate.startDate);
      }

      if (requestToSend.gwDate.endDate)
      {
         requestToSend.gwDate.endDate = dateFormat.getLocalDateEnd(requestToSend.gwDate.endDate);
      }
      else
      {
         requestToSend.gwDate.endDate = dateFormat.getLocalDateEnd(requestToSend.gwDate.startDate);
      }

      if (requestToSend.sealUpdateDate.startDate)
      {
         requestToSend.sealUpdateDate.startDate = dateFormat.getLocalDate(requestToSend.sealUpdateDate.startDate);
      }
          
      if (requestToSend.sealUpdateDate.endDate)
      {
         requestToSend.sealUpdateDate.endDate = dateFormat.getLocalDateEnd(requestToSend.sealUpdateDate.endDate);
      }
      else
      {
         requestToSend.sealUpdateDate.endDate = dateFormat.getLocalDateEnd(requestToSend.sealUpdateDate.startDate);
      }
    
      const st = performance.now();
      //const result = await api.post('/api/w/fsi/WebSearchOutboundList', requestToSend);
      const result = await newAPIPost('/api/w/fsi/WebSearchOutboundList', requestToSend);
      commit('updateSearchOutboundListRequest', fallbackRequest);
      if (requestToSend.loadStatus == 'LD')
      {
        if (result && result.length > 0)
        {
           return commit('updateOutbound', result.filter(it => it.scaleTicket != null));
        } else {
           return commit('updateOutbound', []);
        }
      }
      else
      { 
        if (result && result.length > 0)
        {
           return commit('updateOutbound', result.filter(it => it.loadStatus != 'LD' || (it.loadStatus == 'LD' && it.scaleTicket != null)));
        } else {
            return commit('updateOutbound', []);
        }
      }
    },
  },
  getters: {
    getOutboundsListList: state => state.outbounds,
  },
};
